const usePlacement = (position, isRtl) => {
  const placements = isRtl
    ? {
        top: 'top',
        'top-start': 'top-end',
        'top-end': 'top-start',
        end: 'left',
        'end-top': 'left-start',
        'end-bottom': 'left-end',
        bottom: 'bottom',
        'bottom-start': 'bottom-end',
        'bottom-end': 'bottom-start',
        start: 'right',
        'start-top': 'right-start',
        'start-bottom': 'right-end',
        right: 'left',
        'right-start': 'left-start',
        'right-end': 'left-end',
        left: 'right',
        'left-start': 'right-start',
        'left-end': 'right-end'
      }
    : {
        top: 'top',
        'top-start': 'top-start',
        'top-end': 'top-end',
        end: 'right',
        'end-top': 'right-start',
        'end-bottom': 'right-end',
        bottom: 'bottom',
        'bottom-start': 'bottom-start',
        'bottom-end': 'bottom-end',
        start: 'left',
        'start-top': 'left-start',
        'start-bottom': 'left-end',
        right: 'right',
        'right-start': 'right-start',
        'right-end': 'right-end',
        left: 'left',
        'left-start': 'left-start',
        'left-end': 'left-end'
      };

  return placements[position];
};

export default usePlacement;
